import { View } from 'backbone';
import _ from 'underscore';
import AlertHtml from '../../html/alert.html';
import { getLogger } from '../logging/logger';

const logger = getLogger('Alert');

const ATTRIBUTES = {
	type: 'type',
	message: 'message',
};

/**
 * Determines the visual style of the alert.
 * @typedef {('info' | 'success' | 'danger')} AlertType
 *
 *
 * @typedef {Object} AlertAttributes
 * @property {AlertType} type The visual style of the alert.
 * @property {String} message The text displayed in the alert.
 *
 * @typedef {AlertAttributes & import('backbone').ViewOptions} AlertOptions
 */

export { ATTRIBUTES };

export default class Alert extends View {
	className() {
		return 'alert alert-dismissible';
	}

	get template() {
		return _.template(AlertHtml);
	}

	events() {
		return {
			'click button[data-dismiss=alert]': 'onClose',
			click: 'dismiss',
		};
	}

	/**
	 * Renders the alert
	 * @param {AlertOptions} options Data to populate into Alert template
	 */
	initialize(options) {
		logger.log('[initialize]', { options });

		this.render(options);
	}

	/**
	 * Render the data to the template
	 * @inheritdoc
	 * @param {AlertOptions} data Incoming Data
	 * @returns Self for chaining
	 */
	render(data) {
		logger.log('[render]', { data });

		this.$el.addClass(`alert-${data.type}`).attr('role', 'alert').append(this.template(data));
		return this;
	}

	dismiss() {
		this.$el.fadeOut(300, () => this.$el.remove());
	}
}
